import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const badgeStatusRecipeFn = /* @__PURE__ */ createRecipe('badgeStatus', {
  "variant": "positive"
}, [])

const badgeStatusRecipeVariantMap = {
  "variant": [
    "positive",
    "pending",
    "refused",
    "process"
  ]
}

const badgeStatusRecipeVariantKeys = Object.keys(badgeStatusRecipeVariantMap)

export const badgeStatusRecipe = /* @__PURE__ */ Object.assign(memo(badgeStatusRecipeFn.recipeFn), {
  __recipe__: true,
  __name__: 'badgeStatusRecipe',
  __getCompoundVariantCss__: badgeStatusRecipeFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: badgeStatusRecipeVariantKeys,
  variantMap: badgeStatusRecipeVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, badgeStatusRecipeVariantKeys)
  },
  getVariantProps: badgeStatusRecipeFn.getVariantProps,
})